export default {
  'approvers.title': 'Configuración de Aprobadores',
  'approvers.level': 'Nivel de Aprobación',
  'approvers.dynamicEntity': 'Entidad Dinámica',
  'approvers.dynamicEntityField': 'Campo',
  'approvers.fieldData': 'Valor',
  'approvers.area': 'Área',
  'approvers.entityValue': 'Valor de Entidad',

  'approvers.userGroup.title': 'Gestionar Aprobadores Globales por Grupo de Usuarios',
  'approvers.userGroupPosition.title':
    'Gestionar Aprobadores Globales por Grupo de Usuarios y Puestos',
  'approvers.dynamicEntityUser.title': 'Gestionar Aprobadores Globales por Entidades y Usuarios',
  'approvers.dynamicEntityUserGroup.title':
    'Gestionar Aprobadores Globales por Entidades y Grupos de Usuarios',
  'approvers.dynamicEntityPosition.title': 'Gestionar Aprobadores Globales por Entidades y Puestos',

  'approvers.globalArea.title': 'Gestionar Aprobadores Globales por Grupo de Usuarios y Área',

  'approvers.entityArea.title': 'Gestionar Aprobadores Global por Entidad y Área',
};
